<template>
  <div>
    <headerSection></headerSection>
    <div class="x-main-content x-partner-page"
         :style="{ 'background-image': `url(${require('../assets/images/Shiba-BG.jpg')})`}">
      <div class="container">

        <!-- Page Header -->
        <div class="x-page-header">
          <div class="x-page-title-component">
            <div class="-inner-wrapper">
              <div class="-icon-wrapper">
                <i class="fas fa-users"></i>
              </div>
              <h1 class="-title">ลิงก์รับทรัพย์</h1>
            </div>
          </div>
          <p class="-description">แนะนำเพื่อนรับค่าคอมมิชชั่น</p>
        </div>

        <!-- Banner Image -->
        <div class="x-banner-section">
          <img src="https://firebasestorage.googleapis.com/v0/b/deltaplus-th.appspot.com/o/images%2F-Mz_m0Rf-hUPdBhEvbeI.png?alt=media&token=6002d82a-f0dd-430b-8642-9370d7fb1f46" class="-banner-img" alt="ลิงก์รับทรัพย์">
        </div>

        <!-- Referral Link Section -->
        <div class="x-referral-card">
          <div class="-card-header">
            <i class="fas fa-link"></i>
            <span>ลิงก์แนะนำของคุณ</span>
          </div>
          <div class="-card-body">
            <div class="x-link-group">
              <input type="text" readonly class="-link-input" :value="`https://deltaplus-dp.com/register?ref=${user.code}`">
              <button
                class="-copy-btn"
                v-clipboard:copy="`https://deltaplus-dp.com/register?ref=${user.code}`"
                v-clipboard:success="clipboardSuccessHandler"
              >
                <i class="fas fa-copy"></i>
                <span>คัดลอก</span>
              </button>
            </div>
            <p class="-hint">ส่ง Link ได้ทุกช่องทางรับทรัพย์กับเรา</p>
          </div>
        </div>

        <!-- Stats Section -->
        <div class="x-stats-section">
          <div class="-section-title">
            <i class="fas fa-chart-bar"></i>
            <span>รายได้ผู้แนะนำ</span>
          </div>

          <div class="x-stats-grid">
            <!-- Level 1 Friend Count -->
            <div class="x-stat-card">
              <div class="-icon-circle -blue">
                <i class="fas fa-user-friends"></i>
              </div>
              <div class="-stat-content">
                <span class="-label">แนะนำเพื่อน</span>
                <span class="-value">{{ (this.level1) ? Object.keys(this.level1).length : 0 }}</span>
              </div>
            </div>

            <!-- Level 2 Friend Count -->
            <div class="x-stat-card -clickable" @click="showlevel(2)">
              <div class="-icon-circle -purple">
                <i class="fas fa-user-plus"></i>
              </div>
              <div class="-stat-content">
                <span class="-label">เพื่อนแนะนำเพื่อน</span>
                <span class="-value">{{ (this.level2) ? Object.keys(this.level2).length : 0 }}</span>
              </div>
              <div class="-detail-badge">
                <i class="fas fa-chart-line"></i>
                <span>ดูรายละเอียด</span>
              </div>
            </div>

            <!-- Level 1 Income -->
            <div class="x-stat-card">
              <div class="-icon-circle -green">
                <i class="fas fa-coins"></i>
              </div>
              <div class="-stat-content">
                <span class="-label">รายได้แนะนำเพื่อน</span>
                <span class="-value -gold">{{ (partner && partner.total1) ? numberWithCommas(partner.total1) : '0.00' }}</span>
              </div>
            </div>

            <!-- Level 2 Income -->
            <div class="x-stat-card">
              <div class="-icon-circle -orange">
                <i class="fas fa-hand-holding-usd"></i>
              </div>
              <div class="-stat-content">
                <span class="-label">รายได้เพื่อนแนะนำเพื่อน</span>
                <span class="-value -gold">{{ (partner && partner.total2) ? numberWithCommas(partner.total2) : '0.00' }}</span>
              </div>
            </div>
          </div>

          <!-- Total Income Card -->
          <div class="x-total-card">
            <div class="-total-icon">
              <i class="fas fa-wallet"></i>
            </div>
            <div class="-total-content">
              <span class="-label">รายได้ทั้งหมด</span>
              <span class="-value">{{ (partner && partner.total) ? numberWithCommas(partner.total) : '0.00' }}</span>
            </div>
          </div>

          <!-- Transfer Button -->
          <div class="x-action-section">
            <button
              class="x-transfer-btn"
              :class="{ '-disabled': !partner.total }"
              @click="movePartnerToWallet()"
            >
              <i class="fas fa-exchange-alt"></i>
              <span>โอนเงินเข้ากระเป๋าหลัก</span>
            </button>
          </div>
        </div>

        <!-- Rules Section -->
        <div class="x-rules-card" v-if="detail">
          <div class="-rules-header">
            <i class="fas fa-star"></i>
            <span>รายละเอียดโปรโมชั่น</span>
          </div>
          <div class="-rules-content" v-html="nl2br(detail)"></div>
        </div>

      </div>
    </div>

    <!-- History Modal -->
    <div class="x-modal-overlay" :class="{ '-active': showdetail }" @click.self="closeDetail()">
      <div class="x-modal-content" v-if="showdetail">
        <div class="-modal-header">
          <h2 class="-modal-title">{{ titleDetail }}</h2>
          <button class="-close-btn" @click="closeDetail()">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="-modal-body">
          <p class="-notice">*ข้อมูลสรุปยอดเมื่อวาน</p>
          <div class="x-table-wrapper">
            <table class="x-premium-table">
              <thead>
                <tr>
                  <th>
                    <div class="-th-content">
                      <i class="fas fa-user"></i>
                      <span>รหัส</span>
                    </div>
                  </th>
                  <th>
                    <div class="-th-content">
                      <i class="far fa-calendar-alt"></i>
                      <span>วันที่</span>
                    </div>
                  </th>
                  <th>
                    <div class="-th-content">
                      <i class="fas fa-arrow-down"></i>
                      <span>ฝาก</span>
                    </div>
                  </th>
                  <th>
                    <div class="-th-content">
                      <i class="fas fa-arrow-up"></i>
                      <span>ถอน</span>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in history" :key="index">
                  <td>{{ item.friend }}</td>
                  <td>{{ item.createdateShow }}</td>
                  <td class="-deposit">{{ numberWithCommas(item.deposit) }}</td>
                  <td class="-withdraw">{{ numberWithCommas(item.withdraw) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="x-empty-state" v-if="!history.length">
            <i class="fas fa-inbox"></i>
            <p>ไม่มีข้อมูล</p>
          </div>
        </div>
        <div class="-modal-footer">
          <span class="x-contact-link">
            ติดปัญหา <a href="https://lin.ee/rrSbqfG" target="_blank" rel="noopener">ติดต่อฝ่ายบริการลูกค้า</a>
          </span>
        </div>
      </div>
    </div>

    <footerSection></footerSection>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import router from './../router'
import moment from 'moment-timezone'
const axios = require('axios').default
export default {
  name: 'Partner',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue')
  },
  created () {
	  const user = localStorage.getItem('userData')
	  if (user) {
		  const _user = JSON.parse(user)
		  this.$store.dispatch('user/setUser', _user).catch(err => { console.error(err) })
	  } else {
      firebase.auth().signOut()
      localStorage.removeItem('userData')
      router.replace('/login')
	  }
  },
  data: function () {
    return {
      level1: [],
      level2: [],
      partner: [],
      showdetail: false,
      titleDetail: '',
      history: [],
      detail: ''
    }
  },
  mounted () {
    this.scrollToTop()
    this.getPartner()
  },
  computed: {
    user () {
      return this.$store.state.user.user
    }
  },
  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    movePartnerToWallet () {
      if (this.partner.total && this.partner.key) {
        this.$store.commit('user/SET_LOADING', true)
        axios.get(`https://api.deltaplus-dp.com/qpartner/partner/${this.partner.key}`)
        setTimeout(() => {
          this.getPartner()
          this.$store.commit('user/SET_LOADING', false)
        }, 2000)
      }
    },
    clipboardSuccessHandler () {
      this.$swal({ icon: 'success', title: 'Copy', text: 'คัดลอกเรียบร้อยแล้ว' })
    },
    checkStyle () {
      if (this.partner && this.partner.total > 0) {
        return 'background:linear-gradient(180deg,#f9a25b , #f37320 );height: 43px;min-width:120px;padding-left: 24px;padding-right: 24px;padding-top: 0.8em;'
      } else {
        return 'background: linear-gradient(180deg,#cccccc,#cccccc);height: 43px;min-width:120px;padding-left: 24px;padding-right: 24px;padding-top: 0.8em;'
      }
    },
    getUserId () {
      const user = localStorage.getItem('userData')
      if (user) {
        const _user = JSON.parse(user)
        return _user
      } else {
        firebase.auth().signOut()
        localStorage.removeItem('userData')
        router.replace('/login')
      }
    },
    numberWithCommas (x) {
	  if (!x) x = 0
      return x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    async getPartner () {
      this.detail = (await firebase.database().ref('/partner/detail').once('value')).val()
      const user = this.getUserId()
      if (user) {
        firebase.firestore().collection('partner').where('date', '==', moment().tz('Asia/Bangkok').format('YYYY-MM-DD')).where('userkey', '==', user.key).where('status', '==', false).get().then((snapshot) => {
          if (!snapshot.size) this.partner = []
          snapshot.forEach((doc) => {
            const data = doc.data()
            data.key = doc.id
            this.partner = data
          })
        })
        firebase.firestore().collection('friends').where('userkey', '==', user.key).get().then((result) => {
          result.forEach((doc) => {
            const data = doc.data()
            data.key = doc.id
            if (data.level === 1) {
              this.level1.push(data)
            } else {
              this.level2.push(data)
            }
          })
        })
      }
    },
    nl2br (str, is_xhtml) {
      if (typeof str === 'undefined' || str === null) {
        return ''
      }
      var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>'
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2')
    },
    async showlevel (level) {
      const history = []
      const deposit = []
      const withdraw = []
      if (level === 1) {
        this.titleDetail = 'แนะนำเพื่อน'
        await firebase.firestore().collection('daily_deposit').where('createdate', '==', moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).where('level1', '==', this.user.code).get().then((snapshot) => {
          snapshot.forEach((doc) => {
            deposit[doc.data().code] = doc.data().total
          })
        })
        await firebase.firestore().collection('daily_withdraw').where('createdate', '==', moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).where('level1', '==', this.user.code).get().then((snapshot) => {
          snapshot.forEach((doc) => {
            withdraw[doc.data().code] = doc.data().total
          })
        })
        if (this.level1) {
          for (const x in this.level1) {
            if (deposit[this.level1[x].friend]) {
              this.level1[x].deposit = deposit[this.level1[x].friend]
            } else {
              this.level1[x].deposit = 0
            }
            if (withdraw[this.level1[x].friend]) {
              this.level1[x].withdraw = withdraw[this.level1[x].friend]
            } else {
              this.level1[x].withdraw = 0
            }
            this.level1[x].createdateShow = moment().add(-1, 'days').format('DD MMM,YY')
            history.push(this.level1[x])
          }
        }
      } else {
        this.titleDetail = 'เพื่อนแนะนำเพื่อน'
        await firebase.firestore().collection('daily_deposit').where('createdate', '==', moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).where('level2', '==', this.user.code).get().then((snapshot) => {
          snapshot.forEach((doc) => {
            deposit[doc.data().code] = doc.data().total
          })
        })
        await firebase.firestore().collection('daily_withdraw').where('createdate', '==', moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).where('level2', '==', this.user.code).get().then((snapshot) => {
          snapshot.forEach((doc) => {
            withdraw[doc.data().code] = doc.data().total
          })
        })
        if (this.level2) {
          for (const x in this.level2) {
            if (deposit[this.level2[x].friend]) {
              this.level2[x].deposit = deposit[this.level2[x].friend]
            } else {
              this.level2[x].deposit = 0
            }
            if (withdraw[this.level2[x].friend]) {
              this.level2[x].withdraw = withdraw[this.level2[x].friend]
            } else {
              this.level2[x].withdraw = 0
            }
            this.level2[x].createdateShow = moment().add(-1, 'days').format('DD MMM,YY')
            history.push(this.level2[x])
          }
        }
      }
      this.history = history
      this.showdetail = true
    },
    closeDetail () {
      this.showdetail = false
    }
  }
}
</script>
<style scoped>
.x-partner-page {
  min-height: 100vh;
  padding: 25px 0 120px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
}

/* Page Header */
.x-page-header {
  text-align: center;
  padding: 20px 0;
}

.x-page-title-component .-inner-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
}

.x-page-title-component .-icon-wrapper {
  width: 50px;
  height: 50px;
  background: linear-gradient(180deg, #ffe867 10%, #fe8a02);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 20px rgba(254, 195, 63, 0.5);
}

.x-page-title-component .-icon-wrapper i {
  font-size: 22px;
  color: #1b1b41;
}

.x-page-title-component .-title {
  font-family: 'Kanit', sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: #ffc107;
  margin: 0;
  text-shadow: 0 0 10px rgba(255, 193, 7, 0.3);
}

.-description {
  color: #a0a0a0;
  font-family: 'Kanit', sans-serif;
  font-size: 14px;
  margin-top: 10px;
}

/* Banner Section */
.x-banner-section {
  text-align: center;
  margin-bottom: 20px;
}

.x-banner-section .-banner-img {
  max-width: 100%;
  max-height: 200px;
  border-radius: 15px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
}

/* Referral Card */
.x-referral-card {
  background: rgba(16, 16, 39, 0.95);
  border: 1px solid #fec33f;
  border-radius: 20px;
  overflow: hidden;
  margin-bottom: 20px;
  box-shadow: 0 0 30px rgba(254, 195, 63, 0.15);
}

.-card-header {
  background: linear-gradient(180deg, #7a02fa, #5a01c0);
  padding: 15px 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.-card-header i {
  color: #ffc107;
  font-size: 16px;
}

.-card-header span {
  font-family: 'Kanit', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
}

.-card-body {
  padding: 20px;
}

.x-link-group {
  display: flex;
  gap: 10px;
}

.-link-input {
  flex: 1;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  padding: 12px 15px;
  font-family: 'Kanit', sans-serif;
  font-size: 13px;
  color: #fff;
  outline: none;
}

.-copy-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background: linear-gradient(180deg, #fec33f, #fe8a02);
  border: none;
  border-radius: 10px;
  color: #1b1b41;
  font-family: 'Kanit', sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.-copy-btn:hover {
  transform: scale(1.05);
  box-shadow: 0 0 20px rgba(254, 195, 63, 0.5);
}

.-hint {
  font-family: 'Kanit', sans-serif;
  font-size: 12px;
  color: #a0a0a0;
  text-align: center;
  margin-top: 15px;
  margin-bottom: 0;
}

/* Stats Section */
.x-stats-section {
  background: rgba(16, 16, 39, 0.95);
  border: 1px solid rgba(254, 195, 63, 0.3);
  border-radius: 20px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 0 30px rgba(254, 195, 63, 0.1);
}

.-section-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 20px;
}

.-section-title i {
  color: #ffc107;
  font-size: 18px;
}

.-section-title span {
  font-family: 'Kanit', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
}

.x-stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  margin-bottom: 15px;
}

.x-stat-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  position: relative;
  transition: all 0.3s ease;
}

.x-stat-card.-clickable {
  cursor: pointer;
}

.x-stat-card.-clickable:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: #fec33f;
}

.-icon-circle {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.-icon-circle.-blue {
  background: linear-gradient(180deg, #60a5fa, #3b82f6);
}

.-icon-circle.-purple {
  background: linear-gradient(180deg, #a78bfa, #8b5cf6);
}

.-icon-circle.-green {
  background: linear-gradient(180deg, #4ade80, #22c55e);
}

.-icon-circle.-orange {
  background: linear-gradient(180deg, #fb923c, #f97316);
}

.-icon-circle i {
  color: #fff;
  font-size: 18px;
}

.-stat-content {
  text-align: center;
}

.-stat-content .-label {
  display: block;
  font-family: 'Kanit', sans-serif;
  font-size: 11px;
  color: #a0a0a0;
  margin-bottom: 3px;
}

.-stat-content .-value {
  display: block;
  font-family: 'Kanit', sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #fff;
}

.-stat-content .-value.-gold {
  color: #ffc107;
}

.-detail-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background: rgba(254, 195, 63, 0.2);
  border-radius: 10px;
}

.-detail-badge i {
  color: #ffc107;
  font-size: 10px;
}

.-detail-badge span {
  font-family: 'Kanit', sans-serif;
  font-size: 9px;
  color: #ffc107;
}

/* Total Card */
.x-total-card {
  background: linear-gradient(135deg, rgba(254, 195, 63, 0.15), rgba(254, 138, 2, 0.15));
  border: 1px solid #fec33f;
  border-radius: 15px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  margin-bottom: 20px;
}

.-total-icon {
  width: 50px;
  height: 50px;
  background: linear-gradient(180deg, #fec33f, #fe8a02);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 20px rgba(254, 195, 63, 0.4);
}

.-total-icon i {
  color: #1b1b41;
  font-size: 22px;
}

.-total-content {
  text-align: center;
}

.-total-content .-label {
  display: block;
  font-family: 'Kanit', sans-serif;
  font-size: 12px;
  color: #a0a0a0;
}

.-total-content .-value {
  display: block;
  font-family: 'Kanit', sans-serif;
  font-size: 26px;
  font-weight: 700;
  color: #ffc107;
  text-shadow: 0 0 10px rgba(255, 193, 7, 0.3);
}

/* Action Section */
.x-action-section {
  text-align: center;
}

.x-transfer-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 12px 30px;
  background: linear-gradient(180deg, #f9a25b, #f37320);
  border: none;
  border-radius: 30px;
  color: #fff;
  font-family: 'Kanit', sans-serif;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(243, 115, 32, 0.4);
}

.x-transfer-btn:hover:not(.-disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(243, 115, 32, 0.5);
}

.x-transfer-btn.-disabled {
  background: linear-gradient(180deg, #666, #555);
  cursor: not-allowed;
  box-shadow: none;
}

.x-transfer-btn i {
  font-size: 16px;
}

/* Rules Card */
.x-rules-card {
  background: rgba(16, 16, 39, 0.95);
  border: 1px solid rgba(254, 195, 63, 0.3);
  border-radius: 20px;
  overflow: hidden;
}

.-rules-header {
  background: linear-gradient(180deg, #7a02fa, #5a01c0);
  padding: 15px 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.-rules-header i {
  color: #ffc107;
  font-size: 16px;
}

.-rules-header span {
  font-family: 'Kanit', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
}

.-rules-content {
  padding: 20px;
  font-family: 'Kanit', sans-serif;
  font-size: 13px;
  color: #d0d0d0;
  line-height: 1.6;
  text-align: center;
}

/* Modal Styles */
.x-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  padding: 20px;
}

.x-modal-overlay.-active {
  opacity: 1;
  visibility: visible;
}

.x-modal-content {
  background: rgba(16, 16, 39, 0.98);
  border: 1px solid #fec33f;
  border-radius: 20px;
  max-width: 600px;
  width: 100%;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 50px rgba(254, 195, 63, 0.2);
}

.-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.-modal-title {
  font-family: 'Kanit', sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #ffc107;
  margin: 0;
}

.-close-btn {
  width: 35px;
  height: 35px;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
}

.-close-btn:hover {
  background: rgba(248, 113, 113, 0.3);
  color: #f87171;
}

.-modal-body {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
}

.-notice {
  font-family: 'Kanit', sans-serif;
  font-size: 12px;
  color: #a0a0a0;
  margin-bottom: 15px;
}

.x-table-wrapper {
  overflow-x: auto;
  max-height: 400px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.x-premium-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 400px;
}

.x-premium-table thead {
  position: sticky;
  top: 0;
  z-index: 10;
}

.x-premium-table th {
  background: linear-gradient(180deg, #7a02fa, #5a01c0);
  padding: 0;
}

.x-premium-table th .-th-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 12px 10px;
}

.x-premium-table th .-th-content i {
  color: #ffc107;
  font-size: 12px;
}

.x-premium-table th .-th-content span {
  color: #fff;
  font-family: 'Kanit', sans-serif;
  font-size: 12px;
  font-weight: 600;
}

.x-premium-table td {
  padding: 10px;
  text-align: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  font-family: 'Kanit', sans-serif;
  font-size: 12px;
  color: #fff;
}

.x-premium-table tbody tr:nth-child(odd) td {
  background: rgba(50, 60, 80, 0.4);
}

.x-premium-table tbody tr:nth-child(even) td {
  background: rgba(44, 52, 70, 0.4);
}

.x-premium-table tbody tr:hover td {
  background: rgba(254, 195, 63, 0.1);
}

.x-premium-table td.-deposit {
  color: #4ade80;
  font-weight: 600;
}

.x-premium-table td.-withdraw {
  color: #f87171;
  font-weight: 600;
}

.x-empty-state {
  text-align: center;
  padding: 40px 20px;
}

.x-empty-state i {
  font-size: 40px;
  color: rgba(254, 195, 63, 0.3);
  margin-bottom: 10px;
}

.x-empty-state p {
  font-family: 'Kanit', sans-serif;
  font-size: 14px;
  color: #a0a0a0;
  margin: 0;
}

.-modal-footer {
  padding: 15px 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center;
}

.x-contact-link {
  font-family: 'Kanit', sans-serif;
  font-size: 12px;
  color: #a0a0a0;
}

.x-contact-link a {
  color: #ffc107;
  text-decoration: underline;
}

/* Responsive */
@media (max-width: 576px) {
  .x-link-group {
    flex-direction: column;
  }

  .-copy-btn {
    justify-content: center;
  }

  .x-stats-grid {
    grid-template-columns: 1fr;
  }

  .x-stat-card {
    flex-direction: row;
    justify-content: flex-start;
    padding: 12px 15px;
  }

  .-icon-circle {
    width: 40px;
    height: 40px;
  }

  .-stat-content {
    text-align: left;
  }

  .-detail-badge {
    top: 50%;
    transform: translateY(-50%);
  }

  .x-page-title-component .-title {
    font-size: 20px;
  }

  .x-modal-content {
    max-height: 90vh;
    margin: 10px;
  }
}
</style>
